// extracted by mini-css-extract-plugin
export var dividerContainer = "_8r-0";
export var line = "_8r-1";